<div class="d-lg-block d-none">
  <fgb-banner [title]="'rewards.marketplace.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class=" d-lg-flex flex-column mb-4">
    <div class="container order-2 order-lg-1">
      <div class="description mb-3 my-lg-0 bg-white">
        <div class="text fw-bold">{{ 'rewards.description' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="container">
    <fgbcl-marketplace-list
      [isList]="true"
      [marketplaceItemView]="true"
      [marketplaceItemTypes]="[0, 1, 2, 4, 5]"
      [defaultSort]="0"
    ></fgbcl-marketplace-list>
  </div>
</div>
